// @ts-expect-error
import type {ContextRouter} from 'react-router-dom';

import {ChatOnboarding} from './chat/onboarding/chat-onboarding';
import {AgentSettingsTable} from './chat/settings';
import {ChatSettingsM2} from './chat/settings/chat-settings-m2';
import {TestChatbot} from './chat/test/test-chatbot';
import {Settings as EmailSettings} from './email/settings/settings';
import {Settings as FacebookSettings} from './facebook';
import {SmsSettings} from './sms';
import {Settings as WhatsAppSettings} from './whatsapp';

type Props = ContextRouter;

export function SettingsPage(props: Props) {
    const selectedPage = props.match.params.page;

    switch (selectedPage) {
        case 'chat':
            return <ChatSettingsM2 {...props} />;
        case 'sms':
            return <SmsSettings {...props} startedFrom='engagement' />;
        case 'agents':
            return <AgentSettingsTable />;
        case 'facebook':
            return <FacebookSettings />;
        case 'whatsapp':
            return <WhatsAppSettings />;
        case 'chat-onboarding':
            return <ChatOnboarding />;
        case 'test-chatbot':
            return <TestChatbot />;
        case 'email':
            return <EmailSettings addressId={props.match.params.id} />;
        default:
            return null;
    }
}
